import React, {Component} from 'react';
import {connect} from "react-redux";
import {graphql} from "react-apollo/lib/index";
import CodeScanDataQuerry from '../graphql/CodeScanData.graphql';
import _ from "lodash";
import UpdateCodeScanDataQuerry from "../graphql/UpdateCodeScanDataQuerry.graphql";
import Message from "../enums/Message";
import {actions as system} from "../reducers/system";
import Navigation from "../components/CodeScanner/Navigation";
import ScanButton from "../components/CodeScanner/ScanButton";
import NewLabels from "../components/CodeScanner/NewLabels";
import UpdatedLabels from "../components/CodeScanner/UpdatedLabels";
import NotFoundLabels from "../components/CodeScanner/NotFoundLabels";

@connect(
	state => {
		return {
			selectedProject: state.project.selected,
		}
	},
	dispatch => {
		return {
			addMessage: (message) => dispatch(system.addMessage(message)),
			startLoading: () => dispatch(system.startLoading()),
			endLoading: () => dispatch(system.endLoading())
		}
	})
@graphql(
	CodeScanDataQuerry, {
		skip: props => props.selectedProject === null,
		options: props => {
			return {
				variables: {
					project: props.selectedProject.name
				}
			}
		}
	}
)

@graphql(
	UpdateCodeScanDataQuerry, {
		skip: props => props.selectedProject === null,
		options: props => {
			return {
				variables: {
					project: props.selectedProject.name
				},
				pollInterval: 5000
			}
		},
		name: 'status'
	}
)
export default class CodeScanner extends Component {
	constructor(prop) {
		super(prop);

		this.state = {
			initialDataIsLoaded: false,
		};
	}

	componentDidMount() {
		this.handleGraphqlRequest(null, this.props.data, null, this.props.status);
	}

	componentDidUpdate(prevProps) {
		this.handleGraphqlRequest(prevProps.data, this.props.data, prevProps.status, this.props.status);
	}

	handleGraphqlRequest = (prevData, newData, prevStatus, newStatus) => {
		if (newData && newStatus) {
			if (_.get(prevData, 'loading', false) !== newData.loading) {
				if (newData.loading) {
					this.props.startLoading();
				} else {
					this.props.endLoading();
				}
				if (newData.project && this.state.initialDataIsLoaded !== true && newData.project.codeScan) {
					this.setState({
						initialDataIsLoaded: true,
					});
				}
			}

			if (_.get(prevData, 'error', _.noop()) !== newData.error) {
				this.props.addMessage(new Message(
					Message.TYPE_ERROR,
					500,
					'Could not fetch data of project'
				));
				this.setState({error: true});
			}

			if (_.get(prevStatus, 'error', _.noop()) !== newStatus.error) {
				this.props.addMessage(new Message(
					Message.TYPE_ERROR,
					500,
					'Could not fetch status of project'
				));
				this.setState({error: true});
			}

			if (_.get(prevStatus, 'project.codeScan.isRunning', _.noop()) !== _.get(newStatus, 'project.codeScan.isRunning', _.noop())) {
				if (!newStatus.project.codeScan.isRunning && prevStatus && prevStatus.project)
				{
					this.props.data.refetch({
						variables: {
							project: this.props.selectedProject.name
						}})
					this.props.endLoading();
				}
			}
		}
	};

	renderNoScan(status) {
		return(
			<div className="card" style={{overflow: "auto"}}>
				<div className="card-header">
					<h1>Code Scanner</h1>
				</div>
				<div className="card-body">
					<div>
						<ScanButton data={this.props.data} status={this.props.status} selectedProject={this.props.selectedProject}/>
					</div>
				</div>
			</div>
		)
	}

	render() {
		const {selectedProject, data, status} = this.props;

		if (selectedProject === null || data.error || !data.project || !status.project) {
			return null;
		}

		if (!status.project.codeScan || !data.project.codeScan)
		{
			return (
				this.renderNoScan(status)
			);
		}
		return (
			<div className="card" style={{overflow: "auto"}}>
				<Navigation status={status} data={data} selectedProject={selectedProject} isRunning={status.project.codeScan.isRunning} lastRun={status.project.codeScan.lastRun} newLabelsCount={data.project.codeScan.newLabels.filter(label => label.ignored !== true).length}/>
				<div className="card-body">
					<div id="my-tab-content" className="tab-content">
						<NewLabels status={status} data={data} selectedProject={selectedProject} newLabels={data.project.codeScan.newLabels}/>
						<UpdatedLabels status={status} data={data} selectedProject={selectedProject}/>
						<NotFoundLabels status={status} data={data} selectedProject={selectedProject}/>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./React/src/screens/CodeScanner.js